import { render, staticRenderFns } from "./FormPageDataCatalog.vue?vue&type=template&id=59dfab66"
import script from "./FormPageDataCatalog.vue?vue&type=script&lang=js"
export * from "./FormPageDataCatalog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports